import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.card.background,
      padding: `${spacing.xs}px ${spacing.s}px`,
      borderRadius: constants.radius.view,
      cursor: "pointer",
      userSelect: "none",
    },
    subtitle: {
      fontSize: "0.69em",
      color: theme.text.secondary,
    },
    left: {
      flexGrow: 1,
      marginLeft: spacing.xs,
    },
    titleRow: {
      alignItems: "center",
      gap: 0,
    },
  };

  return styles;
};
